// General
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Static Data
import routeConst from "../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
// Custom Hooks
import useCustomNavigate from "../../custom-hooks/useCustomNavigate-hook";

const ForceFacialMounted = () => {
  // Redux variables
  const verificationDataPassthrough = useSelector(
    (state) => state.registration.verificationDataPassthrough
  );

  // Router variables
  const navigate = useNavigate();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  useEffect(() => {
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [verificationDataPassthrough, navigate]);

  // Utility Functions
  const handlePopState = (event) => {
    if (
      window.location.pathname.includes(
        routeConst.verify.sugarbookVerified.onboarding.path
      ) ||
      window.location.pathname.includes(
        routeConst.verify.sugarbookVerified.status.path
      ) ||
      window.location.pathname.includes(
        routeConst.verify.sugarbookVerified.status.approved.path
      ) ||
      window.location.pathname.includes(
        routeConst.verify.sugarbookVerified.status.rejected.path
      ) ||
      window.location.pathname.includes(
        routeConst.verify.sugarbookVerified.status.rejected.duplicate
      )
    ) {
    } else {
      if (
        verificationDataPassthrough?.facial?.verification_required &&
        (!verificationDataPassthrough?.facial?.verified ||
          !verificationDataPassthrough?.vp3?.verified)
      ) {
        onNavigate(routeConst.verify.sugarbookVerified.onboarding.path, false);
      }
    }
  };

  return <></>;
};

export default ForceFacialMounted;
